module.exports = __webpack_public_path__ + "static/q3-b91c9a74bf9b309865f7b4f0c23ad2ed.png";